<mat-card class="add-new-location-wrapper">
  <mat-card-header style="width: 100%">
    <mat-card-title>
      <span>{{ 'LocationForm.NewLocation' | translate }}</span>
      <span class="spacer"></span>
      <button
        mat-icon-button
        matTooltip="{{ 'General.Close' | translate }}"
        (click)="onCloseButtonClick()"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-card-title>
    <mat-card-subtitle>
      <mat-divider class="divider"></mat-divider>
    </mat-card-subtitle>
  </mat-card-header>

  <mat-card-content>
    <form [formGroup]="formGroup" class="new-location-form-content">
      <div class="row">
        <app-form-field
          [formGroup]="formGroup"
          fieldControlName="organizationId"
          fieldLabel="General.Organization"
          col="3"
          type="select"
          [options]="organizationList"
          [formState]="selectedOrgId"
          localizeOptions="false"
          selectScrolBatchLimit="{{organizationList?.length}}"
        ></app-form-field>
        <app-form-field
          [formGroup]="formGroup"
          fieldControlName="locationName"
          fieldLabel="LocationForm.LocationName"
          col="3"
          type="text"
          [isRequired]="true"
          [errorText]="locationNameDuplicateErrorText"
          [validatorOrOpts]="{
            validators: [
              Validators.required,
              Validators.maxLength(50)
            ],
            asyncValidators: [
              AsyncValidators.locationNameDoesNotAlreadyExist(
                this.locationService,
                this.locationValidationModel,
                this.displayLocationNameAlreadyExistsMessage.bind(this)
              )
            ],
            updateOn: 'change'
          }"
        ></app-form-field>
        <app-address-form-field
          [formGroup]="formGroup"
          fieldControlName="address1"
          fieldLabel="LocationForm.Address1"
          col="3"
          [validatorOrOpts]="[Validators.required, Validators.maxLength(100)]"
          [addressFieldNameMapping]="{
            city: 'city',
            state: 'state',
            postal_code: 'postalCode',
            country: 'country',
            lat: 'lat',
            lon: 'lon'
          }"
          (valueChanged)="onAddressChanged($event)"
        ></app-address-form-field>

        <app-form-field
          [formGroup]="formGroup"
          fieldControlName="address2"
          fieldLabel="LocationForm.Address2"
          col="3"
          type="text"
          [validatorOrOpts]="[Validators.maxLength(100)]"
        ></app-form-field>
      </div>

      <div class="row">
        <app-form-field
          [formGroup]="formGroup"
          fieldControlName="city"
          fieldLabel="LocationForm.City"
          col="3"
          type="text"
          [isRequired]="true"
          [validatorOrOpts]="[Validators.required, Validators.maxLength(50)]"
        ></app-form-field>

        <app-form-field
          [formGroup]="formGroup"
          fieldControlName="state"
          fieldLabel="LocationForm.State"
          col="3"
          type="text"
          [isRequired]="true"
          [validatorOrOpts]="[Validators.required, Validators.maxLength(50)]"
        ></app-form-field>
        <app-form-field
          [formGroup]="formGroup"
          fieldControlName="postalCode"
          fieldLabel="LocationDetails.Zip"
          col="3"
          type="text"
          [isRequired]="true"
          [validatorOrOpts]="[Validators.required, Validators.maxLength(50)]"
        ></app-form-field>

        <app-form-field
          [formGroup]="formGroup"
          fieldControlName="country"
          fieldLabel="LocationForm.Country"
          col="3"
          type="text"
          [isRequired]="true"
          [validatorOrOpts]="[Validators.required, Validators.maxLength(50)]"
        ></app-form-field>

        <!-- geo location fields-->
        <app-form-field
          [formGroup]="formGroup"
          fieldControlName="lat"
          type="hidden"
          col="0"
        ></app-form-field>

        <app-form-field
          [formGroup]="formGroup"
          fieldControlName="lon"
          type="hidden"
          col="0"
        ></app-form-field>
      </div>

      <div class="row">
        <app-form-field
          [formGroup]="formGroup"
          fieldControlName="active"
          type="slide-toggle"
          valueLabel="LocationDetails.Active"
          col="3"
          [formState]="true"
          [appearance]="'standard'"
          [localizeOptions]="false"
        >
        </app-form-field>

        <app-form-field
          [formGroup]="formGroup"
          fieldControlName="primaryContactId"
          fieldLabel="LocationDetails.PrimaryContact"
          col="3"
          type="select"
          [options]="primaryContactDropdown"
          [localizeOptions]="false"
        ></app-form-field>

        <app-form-field
          [formGroup]="formGroup"
          fieldControlName="userLocationNumber"
          fieldLabel="LocationDetails.UserLocationNumber"
          col="3"
          type="text"
          [validatorOrOpts]="[Validators.maxLength(50)]"
        ></app-form-field>

        <app-form-field
          [formGroup]="formGroup"
          fieldControlName="locationMatchText"
          fieldLabel="LocationDetails.LocationMatchText"
          col="3"
          type="text"
          [validatorOrOpts]="[Validators.maxLength(50)]"
        ></app-form-field>
      </div>

      <div class="row">
        <app-form-field
          fieldLabel="LocationDetails.IsShipTo"
          fieldControlName="isShipTo"
          type="checkbox"
          [formGroup]="formGroup"
          [labelPosition]="'after'"
          [formState]="false"
          col="3"
        >
        </app-form-field>

        <app-form-field
          [formGroup]="formGroup"
          fieldControlName="timeZoneId"
          fieldLabel="LocationForm.Timezone"
          col="3"
          type="select"
          [options]="timezoneList"
          [localizeOptions]="false"
          selectScrolBatchLimit="300"
          [validatorOrOpts]="[Validators.required]">
        </app-form-field>
      </div>
    </form>
  </mat-card-content>
  <mat-action-row
    style="display: flex; justify-content: flex-end; width: 100%; gap: 5px"
  >
    <button mat-button color="secondary" (click)="onCancelButtonClick()">
      {{ 'Dialog.Back' | translate }}
    </button>
    <button
      mat-raised-button
      color="primary"
      (click)="onSaveButtonClick()"
      [disabled]="formGroupErrors().length > 0"
      class="add-new-item-button"
    >
      {{ 'Dialog.Save' | translate }}
    </button>
  </mat-action-row>
</mat-card>
